
const ACTIVE = "ACTIVE";
const IN_ACTIVE = "IN_ACTIVE";
const SUNSET = "SUNSET";
const PLANNED = "PLANNED";

const enumInventoryStatuses = {
    [ACTIVE]: 'Active',
    [IN_ACTIVE]: 'Inactive',
    [SUNSET]: 'Sunset',
    [PLANNED]: 'Planned'
}

const enumInventoryPhasedStatus = {
    [ACTIVE]: 'Active',
    [IN_ACTIVE]: 'Inactive',
    [SUNSET]: 'Sunset',
    [PLANNED]: 'Planned'
}

const PHASED_STATUSES = [
    ACTIVE,
    IN_ACTIVE,
    SUNSET,
    PLANNED
];

exports.ACTIVE = ACTIVE;
exports.IN_ACTIVE = IN_ACTIVE;
exports.SUNSET = SUNSET;
exports.PLANNED = PLANNED;
exports.enumInventoryStatuses = enumInventoryStatuses;
exports.enumInventoryPhasedStatus = enumInventoryPhasedStatus;
exports.PHASED_STATUSES = PHASED_STATUSES;